import React from 'react';

export const ModalTemplate = ({ title = "", show, setShowForm, handleCloseForm, children }) => {
  return (
    <div className={`modal-client-form ${!show && "hide-modal-form"}`}>
        <div className='modal-additional-container'>
            <div className='modal-additional-layout d-flex flex-column align-items-center justify-content-center text-white' style={{ gap: '2vh' }}>
                <h2 className='text-uppercase font-weight-light' style={{ fontSize: '1.27vh' }}>{ title }</h2>
                <div className='client-form-content p-5'>
                    <button type='button' onClick={() => !!handleCloseForm ? handleCloseForm(): setShowForm(false)} className='btn btn-home-start btn-exit-client-form'>
                        <div className='button-shadow'></div>
                        <span><i className="fa-solid fa-xmark"></i></span>
                    </button>
                    { children }
                </div>
            </div>
        </div>

        <div className='layout-bg layout-bg-additional'>
        </div>
    </div>
  )
}
